import { Box, ButtonGroup, FormControl } from "@primer/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useCommonContext } from "../../../contexts/common";
import { dm_phong } from "../../../models/response/phong/dm_phong";
import { phongApi } from "../../../api/phongApi";
import { NotifyHelper } from "../../../helpers/toast";
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";
import Modal from "../../../components/ui/modal";
import TextInput from "../../../components/ui/text-input";
import Button from "../../../components/ui/button";
import ModalActions from "../../../components/ui/modal/ModalActions";
import { ts_hocsinh_noitru_status } from "../../../models/response/noi-tru/ts_hocsinh_noitru_status";
import { hocSinhNoiTruStatusApi } from "../../../api/hocSinhNoiTruApi";

interface ITrangThaiDetailModalProps {
  id: number;
  onClose: () => void;
  onSuccess: () => void;
}

const TrangThaiDetailModal = (props: ITrangThaiDetailModalProps) => {
  const [isSaving, setIsSaving] = useState(false);
  const { translate } = useCommonContext();
  const { nam_hoc, dm_coso_id } = useCommonSelectedHook();

  const [formData, setFormData] = useState<ts_hocsinh_noitru_status>({
    id: props.id,
    trang_thai: ""
  });

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setError,
    control,
    setValue,
    formState: { errors },
  } = useForm<ts_hocsinh_noitru_status>({
    defaultValues: {},
  });

  useEffect(() => {
    if (props.id > 0) {
      handleGetVm();
    }
  }, [props.id]);

  const handleGetVm = async () => {
    const res = await hocSinhNoiTruStatusApi.detail(props.id);
    if (res.is_success) {
      const data: ts_hocsinh_noitru_status = {
        ...res.data,
      };
      setFormData(data);
      reset(data);
    } else {
      NotifyHelper.Error(res.message ?? "Error");
    }
  };

  const onSubmit = async (data: any) => {
    setIsSaving(true);
    let res: any;

    const submitData = {
      ...data,
      id: props.id
    };

    if (props.id > 0) {
      res = await hocSinhNoiTruStatusApi.update(submitData);
    } else {
      res = await hocSinhNoiTruStatusApi.insert(submitData);
    }

    if (res.is_success) {
      NotifyHelper.Success("Success");
      props.onSuccess();
    } else {
      NotifyHelper.Error(res.message ?? "Error");
    }
    setIsSaving(false);
  };

  return (
    <Modal
      isOpen
      onClose={props.onClose}
      width={"60%"}
      title={props.id > 0 ? "Cập nhật" : "Thêm mới"}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-12 mb-3">
            <FormControl>
              <FormControl.Label>Trạng thái</FormControl.Label>
              <TextInput
                block
                name="trang_thai"
                register={register}
                errors={errors}
                required
                validateMessage="Vui lòng điền tên trạng thái"
              />
            </FormControl>
          </div>
        </div>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <ButtonGroup>
            <Button onClick={props.onClose}>{translate("Base.Label.Cancel")}</Button>
            <Button variant="primary" type="submit" disabled={isSaving}>
              {translate(props.id > 0 ? "Base.Label.Update" : "Base.Label.Create")}
            </Button>
          </ButtonGroup>
        </Box>

        
      </form>
    </Modal>
  );
};

export default TrangThaiDetailModal;
